import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 flex flex-col gap-2"
}
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "font-medium" }
const _hoisted_4 = ["disabled", "onClick"]

import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useOdinAccess } from "@/composables/useOdinAccess";

// Shows a persistent banner on every admin view while the current Odin user
// holds temporary support access on one or more containers. ANSKNI-54.

export default /*@__PURE__*/_defineComponent({
  __name: 'OdinAccessBanner',
  setup(__props) {

const router = useRouter();
const { sessions, refresh, revoke } = useOdinAccess();
const revokingId = ref<number | null>(null);

onMounted(() => {
  refresh();
});

const onRevoke = async (containerId: number) => {
  revokingId.value = containerId;
  try {
    const switchedAway = await revoke(containerId);
    // If we were working inside the container we just left, get out of it.
    if (switchedAway) router.push("/admin/odin/customers");
  } finally {
    revokingId.value = null;
  }
};

const formatExpiry = (iso: string): string => {
  const d = new Date(iso);
  return d.toLocaleString("sv-SE", { dateStyle: "short", timeStyle: "short" });
};

return (_ctx: any,_cache: any) => {
  return (_unref(sessions).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sessions), (s) => {
          return (_openBlock(), _createElementBlock("div", {
            key: s.containerId,
            class: "flex flex-wrap items-center justify-between gap-3 rounded-lg bg-orange-2 px-4 py-3 text-white shadow"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fa-solid fa-triangle-exclamation" }, null, -1)),
              _createElementVNode("span", _hoisted_3, [
                _cache[0] || (_cache[0] = _createTextVNode(" Du arbetar som support på ", -1)),
                _createElementVNode("strong", null, _toDisplayString(s.containerName), 1),
                (s.expiresAt)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" (till " + _toDisplayString(formatExpiry(s.expiresAt)) + ")", 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("button", {
              class: "rounded-md bg-white/20 px-3 py-1.5 text-sm font-medium hover:bg-white/30 disabled:opacity-50",
              disabled: revokingId.value === s.containerId,
              onClick: ($event: any) => (onRevoke(s.containerId))
            }, _toDisplayString(revokingId.value === s.containerId ? "Avslutar..." : "Avsluta access"), 9, _hoisted_4)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})